import React, { FC, useEffect } from 'react';
import AppRouter from '@/components/AppRouter';
import LayoutMain from '@organisms/layouts/LayoutMain';
import LayoutEmpty from '@organisms/layouts/LayoutEmpty';
import { useTypedSelector } from '@hooks/useTypedSelector';
import { useActions } from '@hooks/useActions';
import Navbar from '@molecules/Navbar/Navbar';
import { TITLE_PREFIX } from '@/configuration';
import Notifications from '@molecules/Notifications';
import ModalMessages from '@molecules/ModalMessages';
import { STORAGE_KEYS } from '@/constants';

const App: FC = () => {
    const { getCurrentUser } = useActions();
    useEffect(() => {
        getCurrentUser(localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) as string);
    }, []);
    const isAuth = useTypedSelector((state) => state.auth.isAuth);

    return (
        <>
            <title>{`${TITLE_PREFIX}`}</title>
            {isAuth ? (
                <LayoutMain header={<Navbar />}>
                    <AppRouter />
                </LayoutMain>
            ) : (
                <LayoutEmpty>
                    <AppRouter />
                </LayoutEmpty>
            )}
            <Notifications />
            <ModalMessages />
        </>
    );
};

export default App;
